import { Mail, Phone } from 'lucide-react'
import BackButton from '../../../components/common/BackButton'
import { useProfessional } from '../../../context/ProfessionalContext'
import EditButton from '../../../components/common/EditButton'
import DeleteButton from '../../../components/common/DeleteButton'
import { useState } from 'react'

const ProfessionalResume = () => {
    const [openEdit, setOpenEdit] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const { detail } = useProfessional()
    if (!detail) return null
    const professional = detail.professional

    return (
        <div className='text-gray-800 dark:text-white/90 flex items-center justify-between'>
            <div className='space-y-1'>
                <div className='flex items-center gap-2'>
                    <BackButton isIconOnly />
                    <h2 className='font-bold text-xl mr-1'>{professional.name}</h2>
                </div>

                <div className='flex items-center gap-1'>
                    <Mail className='w-4 h-4' />
                    <p>{professional.email && professional.email != '' ? professional.email : 'Não informado'}</p>
                </div>
            </div>

            <div className='flex items-center gap-1'>
                <EditButton handleClick={() => setOpenEdit(true)} />
                <DeleteButton handleClick={() => setOpenDelete(true)} />
            </div>
        </div>
    )
}

export default ProfessionalResume
